"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputTypeDemonstrationForm = void 0;
const yup = __importStar(require("yup"));
exports.OutputTypeDemonstrationForm = {
    initialValues: {
        width: 300,
        height: 200,
    },
    inputs: [
        {
            type: "design",
            id: "design",
            name: "Design",
            validation: yup.string().required(),
        },
        {
            type: "select",
            id: "outputType",
            name: "Output Type",
            validation: yup.string().required(),
            options: [
                {
                    label: "Matboard Wall Map",
                    value: "MATBOARD_WALL_MAP",
                },
                {
                    label: "Matboard Wall Map - Single",
                    value: "MATBOARD_WALL_MAP_SINGLE",
                },
                {
                    label: "Vinyl Wall Map",
                    value: "VINYL_WALL_MAP",
                },
                {
                    label: "Vehicle Map",
                    value: "VEHICLE_MAP",
                },
            ],
        },
        {
            type: "number",
            id: "width",
            name: "Width",
            validation: yup.number().required(),
        },
        {
            type: "number",
            id: "height",
            name: "Height",
            validation: yup.number().required(),
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3V0cHV0VHlwZURlbW9uc3RyYXRpb25Gb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2FuZGJveC9pbnB1dHMvZm9ybXMvT3V0cHV0VHlwZURlbW9uc3RyYXRpb25Gb3JtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLHlDQUEyQjtBQUdkLFFBQUEsMkJBQTJCLEdBQW1CO0lBQ3pELGFBQWEsRUFBRTtRQUNiLEtBQUssRUFBRSxHQUFHO1FBQ1YsTUFBTSxFQUFFLEdBQUc7S0FDWjtJQUNELE1BQU0sRUFBRTtRQUNOO1lBQ0UsSUFBSSxFQUFFLFFBQVE7WUFDZCxFQUFFLEVBQUUsUUFBUTtZQUNaLElBQUksRUFBRSxRQUFRO1lBQ2QsVUFBVSxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUU7U0FDcEM7UUFDRDtZQUNFLElBQUksRUFBRSxRQUFRO1lBQ2QsRUFBRSxFQUFFLFlBQVk7WUFDaEIsSUFBSSxFQUFFLGFBQWE7WUFDbkIsVUFBVSxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUU7WUFDbkMsT0FBTyxFQUFFO2dCQUNQO29CQUNFLEtBQUssRUFBRSxtQkFBbUI7b0JBQzFCLEtBQUssRUFBRSxtQkFBbUI7aUJBQzNCO2dCQUNEO29CQUNFLEtBQUssRUFBRSw0QkFBNEI7b0JBQ25DLEtBQUssRUFBRSwwQkFBMEI7aUJBQ2xDO2dCQUNEO29CQUNFLEtBQUssRUFBRSxnQkFBZ0I7b0JBQ3ZCLEtBQUssRUFBRSxnQkFBZ0I7aUJBQ3hCO2dCQUNEO29CQUNFLEtBQUssRUFBRSxhQUFhO29CQUNwQixLQUFLLEVBQUUsYUFBYTtpQkFDckI7YUFDRjtTQUNGO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsUUFBUTtZQUNkLEVBQUUsRUFBRSxPQUFPO1lBQ1gsSUFBSSxFQUFFLE9BQU87WUFDYixVQUFVLEVBQUUsR0FBRyxDQUFDLE1BQU0sRUFBRSxDQUFDLFFBQVEsRUFBRTtTQUNwQztRQUNEO1lBQ0UsSUFBSSxFQUFFLFFBQVE7WUFDZCxFQUFFLEVBQUUsUUFBUTtZQUNaLElBQUksRUFBRSxRQUFRO1lBQ2QsVUFBVSxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUU7U0FDcEM7S0FDRjtDQUNGLENBQUMifQ==